import { legacyApiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BasePlainResource";
class UploadedDocumentResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.documentId = undefined;
        this.filename = "";
        this.documentType = "";
        this.documentTypeDisplayname = "";
        this.mustSign = false;
        this.archived = false;
        this.documentURL = "";
        this.canBeDeleted = false;
    }
    pk() {
        return this.documentId?.toString();
    }
}
UploadedDocumentResource.urlRoot = legacyApiResourceUrl("DocumentGrid/GetUploadedDocumentList");
export { UploadedDocumentResource };
//# sourceMappingURL=UploadedDocumentResource.js.map